// Helper functions for managing row selection

export const shiftRowSlicer = ({ action, sortedRows, lastClicked, isClicked }) => {
	const lastClickedIndex = sortedRows.findIndex(
		({ id }) => id === lastClicked.id
	);

	const actionIndex = sortedRows.findIndex(({ id }) => id === action.id);

	const sliced =
		lastClickedIndex < actionIndex
			? sortedRows.slice(lastClickedIndex, actionIndex + 1)
			: sortedRows.slice(actionIndex, lastClickedIndex + 1);

	const inBetweenRowIds = {};

	for (const { id } of sliced) {
		inBetweenRowIds[Number(id)] = isClicked;
	}

	return inBetweenRowIds;
};

export const createSelectionStateReducer = (shiftOn, ctrlOn) => {
	return (
		newState,
		action,
		{ lastClickedOff, lastClickedOn, selectedRowIds },
		{ sortedRows }
	) => {
		if (action.type === "toggleRowSelected") {
			const hadRows = Object.keys(selectedRowIds).length > 1;

			const isRemember =
				action.value.method === "checkbox" || ctrlOn;

			if (!isRemember) {
				selectedRowIds = {};
			}

			if (action.value.isSelected) {
				if (lastClickedOn && shiftOn) {
					const newSelectedRowIds = shiftRowSlicer({
						action,
						sortedRows,
						lastClicked: lastClickedOn,
						isClicked: true,
					});

					return {
						...newState,
						selectedRowIds: {
							...selectedRowIds,
							...newSelectedRowIds,
						},
					};
				}
				return {
					...newState,
					lastClickedOn: action,
					lastClickedOff: null,
					selectedRowIds: {
						...selectedRowIds,
						[Number(action.id)]:
							action.value.isSelected,
					},
				};
			} else {
				if (lastClickedOff && shiftOn) {
					const unselectedRowIds = shiftRowSlicer({
						action,
						sortedRows,
						lastClicked: lastClickedOff,
						isClicked: false,
					});

					return {
						...newState,
						selectedRowIds: {
							...selectedRowIds,
							...unselectedRowIds,
						},
					};
				}

				return {
					...newState,
					lastClickedOn: null,
					lastClickedOff: action,
					selectedRowIds: {
						...selectedRowIds,
						[Number(action.id)]: isRemember
							? action.value.isSelected
							: hadRows,
					},
				};
			}
		}
	};
};

